import zoomSdk, { Apis } from '@zoom/appssdk'
import Axios from 'axios'
import { logWithBadge } from 'src/utils/logging'

import { ZoomAppStore } from './state'

const { state } = ZoomAppStore

export async function configure() {
  logWithBadge('zoomSdk', 'configure starting')
  state.configResponse = await zoomSdk.config({
    capabilities: [
      'authorize',
      'connect',
      'getAppContext',
      'getMeetingContext',
      'getMeetingJoinUrl',
      'getMeetingParticipants',
      'getMeetingUUID',
      'getUserContext',
      'onActiveSpeakerChange',
      'onAuthorized',
      'onConnect',
      'onMeeting',
      'onMessage',
      'onParticipantChange',
      'openUrl',
      'postMessage',
      'promptAuthorize',
    ],
  })
  logWithBadge('zoomSdk', 'configure', state.configResponse)
}

export async function openUrl(url: string) {
  const normalizedUrl = new URL(url, window.location.origin)

  normalizedUrl.searchParams.append('zoom_app', 'true')

  logWithBadge('zoomSdk', 'openUrl', normalizedUrl)
  zoomSdk.openUrl({ url: normalizedUrl.toString() })
}

export function hasCapability(api: Apis) {
  // Assume unsupported if config response and such are not setup yet
  const supported =
    state.configResponse && state.configResponse.unsupportedApis && !state.configResponse.unsupportedApis.includes(api)

  if (supported) {
    logWithBadge('zoomSdk', 'supported api', api)
  } else {
    logWithBadge('zoomSdk', 'unsupported api', api)
  }

  return supported
}

export async function followContext(contextUrl: string) {
  if (!hasCapability('getAppContext')) {
    state.updatingContext = false
    return false
  }

  state.updatingContext = true

  await zoomSdk.getAppContext().then(async (response) => {
    logWithBadge('context post', contextUrl, response)
    // Post in with Inertia so it follows the redirects
    await Axios.post<{ url: string }>(contextUrl, { context: response.context }).then((response) => {
      if (response.data.url) {
        // This must fully transition the page because we have (likely) just
        // been logged in and need new CSRF tokens
        window.location.assign(response.data.url)
      }
    })

    // It is tempting to now set state.updatingContext = false.
    // However, we can just let the window timer set this to false.
    // If all went well, we will have transitioned to a new page anyway.
  })

  return true
}

export async function getSDKMeetingInformation() {
  const userContext = hasCapability('getUserContext') ? await zoomSdk.getUserContext() : null
  const meetingContext = hasCapability('getMeetingContext') ? await zoomSdk.getMeetingContext() : null
  const meetingUUID = hasCapability('getMeetingUUID') ? await zoomSdk.getMeetingUUID() : null
  const joinUrl = hasCapability('getMeetingJoinUrl') ? await zoomSdk.getMeetingJoinUrl() : null

  return {
    userContext,
    meetingContext,
    meetingUUID,
    joinUrl,
  }
}
